import img1 from "../images/img01.jpg"
import img2 from "../images/img02.jpg"
import img3 from "../images/img03.jpg"
import img4 from "../images/img04.jpg"
import img5 from "../images/img05.jpg"
import img6 from "../images/img06.jpg"
import img7 from "../images/img07.jpg"
import img8 from "../images/img08.jpg"
import img9 from "../images/img09.jpg"
import img10 from "../images/img10.jpg"
import img11 from "../images/img011.jpg"

const data = {
    status: "success",
    items: [
      {
        id: 1,
        title: "Nike LD Waffle Sacai Black Nylon",
        price: 401,
        image: img1,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-LD-Waffle-Sacai-Black-Nylon/Images/Nike-LD-Waffle-Sacai-Black-Nylon/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606321430&w=1000",
        cantidad: 1,
      },
      {
        id: 2,
        title: "Nike Dunk Low Off-White Pine Green",
        price: 304,
        image: img2,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Dunk-Low-Off-White-Pine-Green/Images/Nike-Dunk-Low-Off-White-Pine-Green/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606319825&w=1000",
        cantidad: 1
      },
      {
        id: 3,
        title: "Nike Air Force 1 Low Supreme Black",
        price: 475,
        image: img3 ,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Air-Force-1-Low-Supreme-Box-Logo-Black/Images/Nike-Air-Force-1-Low-Supreme-Box-Logo-Black/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606325289&w=1000",
        cantidad: 1
      },
      {
        id: 4,
        title: "Nike LD Waffle Sacai White Nylon",
        price: 399,
        image: img4,
        img1: "https://stockx-360.imgix.net/Nike-LD-Waffle-Sacai-White-Nylon/Images/Nike-LD-Waffle-Sacai-White-Nylon/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606325338&w=1000",
        cantidad: 1
      },
      {
        id: 5,
        title: "Nike Dunk Low SP Kentucky (2021)",
        price: 405,
        image:img5,
        category: "nike",
        img1: " https://stockx-360.imgix.net/Nike-Dunk-Low-SP-Kentucky/Images/Nike-Dunk-Low-SP-Kentucky/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606322330&w=1000",
        cantidad: 1
      },
      {
        id: 6,
        title: "Nike Dunk Low Off-White University",
        price: 285,
        image:img6,
        img1: "https://stockx-360.imgix.net/Nike-Dunk-Low-Off-White-University-Red/Images/Nike-Dunk-Low-Off-White-University-Red/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606321824&w=1000",
        cantidad: 1
      },
      {
        id: 7,
        title: "Nike Air Max 2 Light Atmos",
        price: 360,
        image:img7,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Air-Max-2-Light-Atmos/Images/Nike-Air-Max-2-Light-Atmos/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606320966&w=1000",
        cantidad: 1
      },
      {
        id: 8,
        title: "Nike Air Force 1 Low CLOT Blue Silk",
        price: 335,
        image:img8 ,
        img1: "https://stockx-360.imgix.net/Nike-Air-Force-1-Low-Clot-Blue-Silk/Images/Nike-Air-Force-1-Low-Clot-Blue-Silk/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606325265&w=1000",
        cantidad: 1
      },
      {
        id: 9,
        title: "Nike Air Max 90 OG Volt (2020)",
        price: 799,
        image: img9 ,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Air-Max-90-OG-White-Particle-Grey-Volt/Images/Nike-Air-Max-90-OG-White-Particle-Grey-Volt/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1606323250&w=1000",
        cantidad: 1
      },
      {
        id: 10,
        title: "Nike Dunk High Varsity Maize",
        price: 501,
        image:img10,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Dunk-High-Black-Varsity-Maize/Images/Nike-Dunk-High-Black-Varsity-Maize/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1609445259&w=1000",
        cantidad: 1
      },
      {
        id: 11,
        title: "Nike Air Rubber Dunk Off-White UNC",
        price: 377,
        image: img10,
        category: "nike",
        img1: "https://stockx-360.imgix.net/Nike-Air-Rubber-Dunk-Off-White-UNC/Images/Nike-Air-Rubber-Dunk-Off-White-UNC/Lv2/img",
        img2: ".jpg?auto=format,compress&q=90&updated_at=1609438911&w=1000",
        cantidad: 1
      },
    ],
  };
  
  export default data;